export default __webpack_public_path__ + "static/media/fileIcon.38952e86.svg";